import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/WOW13LRG.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>April 07, 2025</ClientTag>
                            <Title>IV Therapy</Title>
                            <TechniqueTitle>
                            Should I book an IV Therapy Appointment
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>If nutrients fuel your health, does the delivery method matter? Absolutely—yes!</p>
                    <p className='content'>When you take nutrients orally, they journey through your digestive system, liver, and kidneys before reaching your cells. This process is usually beneficial, as it helps your body filter out excess and maintain balance. However, it can also reduce the potency of certain nutrients—especially when therapeutic doses are needed.</p>
                     <p className='content'>That’s where IV therapy comes in! </p>
                     <p className='content'>Through delivery of nutrients directly into your bloodstream, IV therapy bypasses the digestive tract entirely. This allows for faster absorption and higher concentrations of vitamins, minerals, and antioxidants where they’re needed most. </p>
                     <p className='content'>IV therapy is a smart, efficient way to give your body exactly what it needs - right when it needs it! </p>

                  
                    <h3 className='my-5'>Who Benefits Most from IV Therapy?</h3>
                    <div>
                      <p className='content'>1. Individuals with digestive or absorption challenges </p>
                      <p className='content'>2. Those taking medications that interfere with nutrient uptake </p>
                      <p className='content'>3. Rapid rehydration after illness, exercise, or travel </p>
                      <p className='content'>4. Emergency situations requiring immediate nutrient support </p>
                      <p className='content'>5. High-dose nutrient delivery to support immunity, prevent chronic disease, and optimism overall wellness </p>
                      <p className='content'>6. Speak with your naturopathic doctor if IV Therapy is right for you and your health! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW13" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);